import { render, staticRenderFns } from "./CompanyBasic.vue?vue&type=template&id=bfce54ea&scoped=true&"
import script from "./CompanyBasic.vue?vue&type=script&lang=js&"
export * from "./CompanyBasic.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBasic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompanyBasic.vue?vue&type=style&index=1&id=bfce54ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfce54ea",
  null
  
)

export default component.exports